import { on as onEvent } from "common/utils/ui/event";
import { storage } from "common/utils/storage";

const STORAGE_KEY = "user-box-saved-projects-notification-dismissed";

// Getters

const $getNotifications = () => document.querySelectorAll(".user-box-saved-projects-notification");

const getIsDismissed = () => storage.get(STORAGE_KEY) === true;

// Setters

const setNotificationVisibility = ($notifications, isVisible) => {
  $notifications.forEach($notification => {
    $notification.classList.toggle("hidden", !isVisible);
  });
};

const setDismissedState = isDismissed => {
  storage.set(STORAGE_KEY, isDismissed);
};

// Actions

const showNotifications = () => {
  const $notifications = $getNotifications();
  setNotificationVisibility($notifications, true);
};

const dismissNotification = () => {
  const $notifications = $getNotifications();
  setNotificationVisibility($notifications, false);
  setDismissedState(true);
};

const handleNotificationClick = event => {
  event.stopPropagation();
  event.preventDefault();
};

const handleCloseClick = event => {
  event.stopPropagation();
  event.preventDefault();
  dismissNotification();
};

// Inits

const initNotificationHandles = () => {
  onEvent("click", ".user-box-saved-projects-notification", handleNotificationClick);
  onEvent("click", ".js-user-box-notification-close", handleCloseClick);
};

const initUserBoxNotification = () => {
  if (getIsDismissed()) {
    return;
  }

  showNotifications();
  initNotificationHandles();
};

export default initUserBoxNotification;
